import { render, staticRenderFns } from "./Informes.vue?vue&type=template&id=457c822e&scoped=true&"
import script from "./Informes.vue?vue&type=script&lang=ts&"
export * from "./Informes.vue?vue&type=script&lang=ts&"
import style0 from "./Informes.vue?vue&type=style&index=0&id=457c822e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c822e",
  null
  
)

export default component.exports